export const lang = {
  lang: '英文',
  lang1: '中文',
  // lang: '中文',
  // lang1: '英文',
  usersLogin: '用户登录', // Users Login
  userName: '姓名',
  password: '密码',

  // 公共
  footer1: '北京海兰信数据科技股份有限公司',
  footer2: '京公安网安备',
  home: '首页',
  information: '信息公告',
  about: '关于我们',
  contact: '联系我们',
  top: "海兰信在线培训系统入口",
  personalcenter: "个人中心",
  logout: '退出登录',
  login: '登录',  // Login
  // 提交验证
  check_name: "用户名不可为空",
  check_email: "邮箱不可为空",
  check_code: "验证码不可为空",
  check_password: "密码不可为空",
  check_password_: "密码不一致",
  check_realName: '真实姓名不得为空',
  // 首页
  Checkcertificate: '查证书',
  Certificateauthenticityquery: "证书真伪查询",
  Clicktoenter: "点击进入",
  Checkqualification: "查资质",
  Service: '服务公司及工程师资质真伪查询',
  Applyforcertificate: 'COC申请',
  Customs: "申请入口",
  Companyprofile: '公司简介',
  txt: '公司业务范围覆盖航海领域的商船、海工特种船、公务船、渔船、舰船等多种船型，以及海洋信息化领域的物理海洋、海洋测绘、水下工程、海底观测、海上无人系统、海域管理等。公司一直是相关领域政府机构的供应商，为此类客户提供综合导航系统以及基于船端和岸基对海的监控管理系统等产品及服务。同...时，公司服务...于远洋运输、海洋工程、海洋科学考察、海洋环境以及海洋渔业等民用领域，为客户提供综合导航、海洋信息与监控管理等产品及服务。',
  Learnmore: '了解更多',

  // 信息公告详情
  Relevantannouncements: '相关公告',
  Last: "上一篇",
  Next: "下一篇",

  // 公司简介
  Companyprofile: '公司简介',
  abouttext1: "海兰信成立于2001年，2010年3月26日在深圳证券交易所上市。公司总部位于北京环保科技园，在海南三沙、广东、上海等地设有分支机构，在德国、新加坡、俄罗斯、加拿大等地设有分公司及研发中心。海兰信遵循“自主研发为基础、国际合作创一流”的研发理念，汇集了200余人的国际化研发团队，拥有近百项专利和软件著作权。2020年集团总人数超过600人，产值10亿元。",
  abouttext2: "公司业务范围覆盖航海领域的商船、海工特种船、公务船、渔船、舰船等多种船型，以及海洋信息化领域的物理海洋、海洋测绘、水下工程、海底观测、海上无人系统、海域管理等。公司一直是相关领域政府机构的供应商，为此类客户提供综合导航系统以及基于船端和岸基对海的监控管理系统等产品及服务。同时，公司服务于远洋运输、海洋工程、海洋科学考察、海洋环境以及海洋渔业等民用领域，为客户提供综合导航、海洋信息与监控管理等产品及服务。",
  abouttext3: "公司“海事+海洋”的综合对海业务模式，可以为客户提供船舶通导智能化系统解决方案、岸基和船载/舰载对海监控管理服务的同时，构建起“近岸+近海+中远海”与“水面+水下”相结合的“海空天一体化”海洋监测网和海洋信息化数据平台，为海域使用管理、海洋环境保护、海洋资源勘探和开发利用、海洋执法监察等工作提供有效的数据决策信息。",

  // 关于我们
  Office1: "广州办",
  Office2: "上海办",
  Office3: "武汉办",
  Office4: "南通办",
  Office5: "海南办",
  hotline: '服务热线',
  mailbox: '邮箱',
  address: '地址',
  address1: '广州市天河区天河软件园建中路62号迪宝大厦6楼',
  address2: '上海市徐汇区龙吴路777号7号楼301室',
  address3: '武汉东湖高新区高新大道光谷六路国采中心写字楼T5号8楼',
  address4: '江苏省南通市崇州区清枫路199号',
  address5: '海南省海口市国兴大道国瑞大厦C座2207、2208室',

  // 查证书
  inspectioncertificate: '证书查寻',
  COCcertificatenumber: "检测你的COC证书的真伪，通过输入COC证书号查询",
  Startquery: "开始查询",
  Thetestresultsareasfollows: "检测结果如下",
  Thecertificateistestedtobetrueandvalid: "该证书经检测真实有效！",
  Thecertificatedoesnotexist: "该证书不存在！",
  mattersneedingattention: "注意事项",
  certinficatetxt1: "域名验证DV COC证书查询后公司名称显示空白。",
  certinficatetxt2: "查询自己签发的COC证书，证书链信息显示不完整属正常，为了你的网站安全，最好及时升级到权威COC证书！",
  certinficatetxt3: "加纳CTN是中国出口到西非国家的商品必须向当地申请电子货物的号码，必须显示在提单上，如果没有加纳CTN就会罚款，说白了就是相当于快递单号，这些国家包括加纳特马，阿克拉，库马西，塔克拉底都必须申请加纳CTN。根据加纳GHANA法令，自2018年3月1日起，所有发货至加纳特马、阿克拉、库马西、塔克拉底、塔马利的货物都必须向ZKTEST申请CTN (Cargo Tracking Notes) number。如果没有申请此货物单将视为触犯加纳的条例，并在目的港受到严厉惩罚。",
  Quickentrance: "快捷入口",

  // 查资质
  qualification1: '服务公司及工程师资质真伪查询',
  qualification2: '检测资质真伪，通过输入公司 或者个人资质证书号查询',

  // 证书申请
  CertificateApplication: "证书申请",
  applytit1: "VDR设备信息",
  applytit2: "船舶基本信息",
  applytit3: "检验公司信息",
  applytit4: "上传附件资料",
  nextstep: "下一步",
  Previousstep: "上一步",
  ConfirmSubmission: "确认提交",
  Fail:"失败",
  apply1: {
    tit1: "VDR主机序列号",
    tit2: "VDR型号",
    tit3: "PDC序列号",
    tit4: "信标序列号",
    tit5: "信标有效期",
    tit6: "FFC序列号",
    tit7: "FFC电池有效期",
    tit8: "静水压力释放期有效期",
    tit9: "VDR备用电池有效期",
    tit10: "VDR软件版本",
  },
  apply2: {
    tit1: "船名",
    tit2: "联系邮箱",
    tit3: "船东",
    tit4: "联系电话",
    tit5: "船籍国",
    tit6: "船级社",

  },
  apply3: {
    tit1: "检验公司名称",
    tit2: "检验公司邮箱地址",
    tit3: "检验公司资质证书编号",
    tit4: "检验工程师姓名",
    tit5: "检验工程师资质证书编号",
    tit6: "检验公司船级社证书编号",
    tit7: "检验时间",
    tit8: "检验地点"
  },
  apply4: {
    tit1: "材料名称",
    tit2: "附件名称",
    tit3: "操作",
    uploadFile: "上传文件",
    name1: '01、VDR配置文件',
    name2: '02、海兰信年检测试报告',
    name3: '03、船级社APT测试报告',
    name4: '04、FFC写码报告',
    name5: '05、PDC数据（5分钟）',
    name6: '06、 FFC数据（5分钟）',
    name7: '07、 LRU数据（5分钟）',
    name8: '08、日志',
    name9: '09、工程师资质证书',
    name10: '10、 工程服务报告',
    name11: '11、主机照片带系列号',
    name12: '12、PDC照片',
    name13: '13、FFC照片',
    name14: '14、OPU照片',
    txt1: "(备用电池有效期、主机箱内整体)",
    txt2: "(PDC系列号、PDC接线盒、信标系列号、信标有效期)",
    txt3: "(FFC系列号、FFC接线盒、电池有效期、有效期标志粘贴)",
  },

  // 个人中心
  PersonalCenter: '个人中心',
  Personal: {
    Basicinformation: "基本资料",
    Auditlist: "审核列表",
    Mycertificate: "我的证书",
    ChangePassword: "修改密码",
    ReturntoPersonalCenter: "返回个人中心",
    headportrait: "修改头像",
    Realname: "真实姓名",
    Company: "所属公司",
    Enterprisemailbox: "企业邮箱",
    Registrationtime: "注册时间",
    LastIPaddress: "上次IP地址",
    Lastlogin: "上次登录",
    OldPassword: "旧密码：",
    NewPassword: "新密码：",
    ConfirmPassword: "确认密码：",
    VerificationCode: "验证码：",
    preservation: "保存",
    title: "船名",
    Applicationtime: "申请时间",
    applicant: '申请人',
    Auditstatus: "审核状态",
    operation: "操作",
    Underreview: "待审核",
    Approved: "审核通过",
    Auditfailed: "审核未通过",
    PendingSubmission: "待提交",
    revoke: "撤销申请",
    Viewdetails: "查看详情",
    Reapply: "再次申请",
    back: '返回',
    essentialinformation: 'Essential information',
    Email: "邮箱",
    get_vCode: "获取验证码",
	delete: "删除",
	search: "搜索"
  },
  audit: {
    name1: "船名",
    name2: "VDR序列号",
    name3: "VDR型号",
    name4: '软件版本',
    name5: "PDC序列号",
    name6: "PDC型号",
    name7: "FFC序列号",
    name8: "FFC型号",
    name9: "信标序列号",
    name10: "信标型号",
    name11: "信标有效期",
    name12: "FFC电池序列号",
    name13: "FFC电池型号",
    name14: "FFC电池有效期",
    name15: "静水压力释放器型号",
    name16: "有效期",
    name17: "备用电池有效期",
    name18: "检验公司名称",
    name19: "资质证书编号",
    name20: "检验工程师名字",
    name21: "资质证书编号",
    name22: "检验日期",
    name23: "检验地点",
    name24: "证书编号",
    name25: "证书有效期",
    name26: "正在审核中，请耐心等待",
    name27: "审核信息",
    name28: "审核员名字",
    name29: "审核结论",
  },
  certificate: {
    MyCertificate: "我的证书",
    Certificatename: "证书名称",
    CertificateNo: "证书编号",
    Gettime: "获得时间",
    Termvalidity: "有效期限",
    operation: "操作",
    ViewCertificate: "查看证书",
    TheDownloadfile: "下载文件"

  },
  customer_cert_1: '个人资质',
  customer_cert_2: '企业资质'
}

